export default __webpack_public_path__ + "img/7dabc59912cffe53dbac337ae0c16da5.svg";